{
  "header": {
    "title": "Tesorería / Libro Mayor de la Empresa",
    "refresh": "Actualizar"
  },
  "kpis": {
    "totalBase": "Capital Base Total",
    "totalWithdrawable": "Total Retirable",
    "totalUnsettledProfit": "Ganancia Total No Liquidada",
    "companyBalance": "Saldo de la Empresa",
    "totalPoolValue": "Valor Total del Fondo",
    "poolValueDescription": "Base + Retirable + No Liquidado + Saldo Empresa",
    "activeUsers": "Usuarios Activos"
  },
  "liquidity": {
    "title": "Planificación de Liquidez - Próxima Liquidación",
    "pendingWithdrawals": "Retiros Aprobados Pendientes",
    "projectedSettlement": "Pago de Liquidación Proyectado",
    "totalCashNeeded": "Efectivo Total Necesario",
    "suggestedTransfer": "Transferencia Bancaria Sugerida",
    "transferIn": "Transferir fondos DESDE el banco a la plataforma",
    "transferOut": "Transferir fondos DESDE la plataforma al banco",
    "noTransfer": "No se necesita transferencia"
  },
  "ledger": {
    "title": "Entradas del Libro Mayor de la Empresa",
    "columns": {
      "date": "Fecha",
      "kind": "Tipo",
      "description": "Descripción",
      "amount": "Monto",
      "balance": "Saldo Después",
      "createdBy": "Creado Por"
    },
    "kinds": {
      "company_cut": "Corte de la Empresa",
      "fee_adjustment": "Ajuste de Comisión",
      "bank_transfer_out": "Transferencia al Banco",
      "bank_transfer_in": "Transferencia desde Banco",
      "withdrawal_paid": "Retiro Pagado",
      "correction": "Corrección",
      "manual_adjustment": "Ajuste Manual",
      "company_cut_credited": "Corte de Empresa Acreditado",
      "company_float_added": "Flotante Añadido",
      "company_withdrawable_added": "Retirable Añadido",
      "company_float_swept_to_withdrawable": "Flotante Movido",
      "company_sweep_paid_out": "Barrido Pagado",
      "company_sweep": "Barrido de Empresa",
      "company_deposit_received": "Depósito Recibido",
      "company_payout_sent": "Pago Enviado",
      "company_payout_returned": "Pago Devuelto"
    }
  },
  "pool": {
    "title": "Composición del Fondo - 100 Usuarios Activos Principales",
    "description": "Mostrando usuarios con los saldos más grandes para comprender la composición del fondo",
    "columns": {
      "rank": "#",
      "name": "Nombre",
      "base": "Capital Base",
      "withdrawable": "Retirable",
      "profitWeek": "Ganancia (Semana)",
      "oneTime": "Retirable Único"
    }
  },
  "adjustment": {
    "button": "Ajuste Manual",
    "modalTitle": "Crear Entrada Manual en el Libro Mayor",
    "kind": "Tipo de Entrada",
    "kindRequired": "Por favor seleccione un tipo de entrada",
    "amount": "Monto (USD)",
    "amountRequired": "Por favor ingrese un monto",
    "description": "Descripción",
    "descriptionRequired": "Por favor ingrese una descripción",
    "descriptionPlaceholder": "Explique el motivo de este ajuste...",
    "submit": "Crear Entrada",
    "cancel": "Cancelar",
    "success": "Entrada manual en el libro mayor creada exitosamente"
  },
  "errors": {
    "fetchSummary": "Error al cargar el resumen de tesorería",
    "fetchLedger": "Error al cargar las entradas del libro mayor",
    "createAdjustment": "Error al crear el ajuste manual"
  }
}
